import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import {
  defer,
  combineLatest
} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  tap,
  map,
  filter,
  switchMap
} from 'rxjs/operators';
import { SetFeatures } from './feature-flags.actions';
import { DigiAIXCoreAppState } from '../app-state';
import {
  Store,
  select
} from '@ngrx/store';
import {
  getFeatureFlagsConfig,
  getEnvironmentName
} from '../config/config.selectors';
import { NGXLogger } from 'ngx-logger';
import { FeatureFlag } from './feature-flag';

@Injectable()
export class FeatureFlagsEffects {
  @Effect({ resubscribeOnError: true })
  public init$ = defer(() => {
    return combineLatest(
      this.store$.pipe(
        select(getFeatureFlagsConfig),
        filter((config) => !!config),
      ),
      this.store$.pipe(
        select(getEnvironmentName),
        filter((environment) => !!environment),
      ),
    ).pipe(
      switchMap(([config, environment]) =>
        this.http
          .get<{ features: FeatureFlag[] }>(config.url + '/client/features', {
            headers: {
              'UNLEASH-APPNAME': environment + '',
              'UNLEASH-INSTANCEID': config.instanceId + '',
            },
          })
          .pipe(
            map((response) => response.features),
            tap((features) =>
              this.logger.debug('Feature flags loaded', features),
            ),
            map((features) => new SetFeatures(features)),
          ),
      ),
    );
  });

  constructor(
    public store$: Store<DigiAIXCoreAppState>,
    public http: HttpClient,
    public logger: NGXLogger,
  ) {}
}
